import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const UnknownIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Unknown terrain - question mark */}
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9a3 3 0 0 1 5.5 1.5c0 1.5-2.5 2-2.5 4" />
    <circle cx="12" cy="17" r="0.5" fill="currentColor" />
  </svg>
);
